var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ isVertical: _vm.vertical, 'is-tab': _vm.isTab },attrs:{"id":"tab-container"}},_vm._l((_vm.tabs),function(tab){return _c('div',{key:tab.key,staticClass:"tab",class:{ active: _vm.activeKey === tab.key },on:{"click":function($event){return _vm.selectTab(tab.key)}}},[_vm._v("\n    "+_vm._s(tab.text)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }